import React, { useState } from 'react';
import { links } from '../data/menuLinks';
import { Link, navigate } from 'gatsby';
import firebase from 'gatsby-plugin-firebase';
import { AiOutlineClose } from 'react-icons/ai';
import { useAuth } from '../context/auth';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import { socialLinks } from '../data/Social';

function Navigation({ menuState, toggleMenu }) {
  const { user } = useAuth();

  const [activeLink, setActiveLink] = useState('');

  const toggleLink = (text) => {
    if (text === activeLink) return setActiveLink('');
    setActiveLink(text);
  };

  const logout = async () => {
    await firebase.auth().signOut();
    toggleMenu();
    navigate('/');
  };

  return (
    <>
      <nav className={`navbar ${menuState && 'menu-open'}`}>
        <div className='menu-container'>
          <div className='menu-header'>
            <span>Menu</span>
            <AiOutlineClose className='close' onClick={toggleMenu} />
          </div>
          <ul className='menu-links'>
            {links.map((link) => (
              <li key={link.id} className='menu-link'>
                <div className='linkText' onClick={() => toggleLink(link.text)}>
                  <Link onClick={toggleMenu} className='menu-link-text' to={link.url}>
                    {link.text}
                  </Link>
                  {link.subLinks && <IoIosArrowForward className='arrow' />}
                </div>
                <div className='mobile-dropdown'>
                  {link.text === activeLink &&
                    link.subLinks?.map((link, i) => (
                      <Link key={i} to={link.url} onClick={toggleMenu}>
                        {link.text}
                      </Link>
                    ))}
                </div>
              </li>
            ))}
          </ul>

          {user ? (
            <>
              <div className='menu-buttons'>
                <p className='user'>
                  {user.displayName ? user.displayName : user.email ? user.email?.split('@')[0] : ''}
                </p>
                <button onClick={logout} className='btn btn-sm btn-danger logout-btn'>
                  Logout
                </button>
              </div>
            </>
          ) : (
            <div className='menu-buttons'>
              <Link onClick={toggleMenu} to='/login'>
                <button className='btn btn-sm btn-success'>Login</button>
              </Link>
              <Link onClick={toggleMenu} to='/signup'>
                <button className='btn btn-sm btn-success'>Register</button>
              </Link>
            </div>
          )}

          <div className='social-links-horizontal'>
            {socialLinks.map((social) => (
              <a
                key={social.id}
                target='_blank'
                href={social.url}
                className='social-link'
                style={{ color: social.color }}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navigation;
